var input = document.getElementById('autocomplete');
if (input) {
    var autocomplete = new google.maps.places.Autocomplete(input);
    // Create a new session token.
    var sessionToken = new google.maps.places.AutocompleteSessionToken();
    // Pass the token to the autocomplete service.
    var autocompleteService = new google.maps.places.AutocompleteService();
    autocompleteService.getPlacePredictions({
        input: 'type an address',
        sessionToken: sessionToken
    },
    displaySuggestions);
            
    var displaySuggestions = function(status) {
    // if the status returned is not 'OK', which means an error, it would send an alert with the text code of the error
    if (status != google.maps.places.PlacesServiceStatus.OK) {
        alert(status);
        return;
        }
    };
}